// NOTE: コーポレートサイトのお問い合わせ用URL。dietplus.jpのフッターなどで使用
export const CONTACT_URL_BASE = 'https://fitsplus.co.jp/contact';
export const CONTACT_URL = `${CONTACT_URL_BASE}?${new URLSearchParams({
  from: 'dietplusjp',
}).toString()}`;
